//? ESLint is disabled so that the constants remain on a single line.
/* eslint-disable */

//?react query keys
export const EXCHANGE_QUERY_KEYS = {
  all: ["EXCHANGE"],
  lists: () => [...EXCHANGE_QUERY_KEYS.all, "list"],
  search: (filters) => [...EXCHANGE_QUERY_KEYS.all, { filters }],
  stats: (filters) => [...EXCHANGE_QUERY_KEYS.all, "stats", { filters }],
  list: (filters) => [...EXCHANGE_QUERY_KEYS.lists(), { filters }],
  shipping_options: (filters) => ["EXCHANGEhippingOptions", { filters }],
  delivery_shipping_options: (filters) => ["sendShipingOption", { filters }],
  return_shipping_options: (filters) => ["returnShipingOption", { filters }],
  exchange_external_reference: (filters) => ["exchangeExternalRef", filters],
  zip: (filters) => ["exchangeZip", { filters }],
};

export const EXCHANGE_ACTIVE_STATUS = "active";

//? types
export const EXCHANGE_TYPES = {
  exchange_and_return: "Directo",
  synchronized: "Posdevolución",
  unsynchronized: "Flexible",
};

//? CREATION STEPS
export const EXCHANGE_STEPS = {
  seller: "Vendedor",
  variants: "Variantes",
  order: "Pedido",
  type: "Tipo",
  address: "Dirección",
  return_step: "Devolución",
  new_delivery: "Nueva entrega",
  buyer: "Comprador",
};

//? ACCEPTED TABS
export const EXCHANGE_TABS = ["All", "active", "finished"];
